export default __webpack_public_path__ + "static/media/featureImage2.cb89ab9d.png";